<template>
  <div v-if="regHorse && regHorse.beddingType">
    <small :key="regHorse.beddingType">
      <v-icon size="small">$iconBoxCheck</v-icon
      ><span class="ml-1">{{
        $t(
          "horses:appShowHorse.beddingType." + regHorse.beddingType + ".text",
          regHorse.beddingType.toLowerCase()
        )
      }}</span>
    </small>
  </div>
</template>
<script>
import { defineComponent, computed, toRefs } from "vue";
import gql from "fraql";

export default defineComponent({
  name: "AppShowBeddingType",
  props: {
    horse: {
      type: Object,
      required: true
    },
    registrationHorses: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const { horse, registrationHorses } = toRefs(props);
    const regHorse = computed(() => {
      if (registrationHorses.value.length) {
        return registrationHorses.value.find(rh => {
          return rh.horseId == horse.value.id;
        });
      }
      return null;
    });

    return { regHorse };
  },
  fragments: {
    horseFields: gql`
      fragment _ on Horse {
        id
      }
    `,
    registrationHorseFields: gql`
      fragment _ on RegistrationHorse {
        id
        horseId
        beddingType
      }
    `,
    registrationFields: gql`
      fragment _ on Registration {
        horses {
          id
        }
        registrationHorses {
          id
          horseId
          beddingType
        }
      }
    `
  }
});
</script>
